import Vue from 'vue'
import JsonApiObject from '@/_models/JsonApi'
import ExportDialog from '@/views/Project/Observation/dialogs/export/export.vue'

export default class ExportModel extends JsonApiObject {
    public constructor(data: any) {
        super(data)
    }
    loading = false

    format
    status
    filename
    fileId
    size
    createdAt
    completedAt
    expiresAt

    get expired() {
        return new Date(this.expiresAt) < new Date(new Date().toDateString())
    }

    async download() {
        this.loading = true
        await Vue.prototype.$vbit.download(this.fileUrl, this.filename)
        this.loading = false
    }

    static showExportDialog() {
        JsonApiObject.openDialog(ExportDialog, {})
    }

    static async post(query) {
        let res = await Vue.prototype.$vbit.post('observation', `exports`, query)
        return new ExportModel(res.data)
    }

    static async get(id: string) {
        let res = await Vue.prototype.$vbit.get('observation', `exports/${id}`)
        return new ExportModel(res.data)
    }

    static async download(fileId: string, filename: string) {
        Vue.prototype.$vbit.download(this.getFileUrl(fileId), filename)
    }
}
